import React, { Component } from 'react';
import PropTypes from 'prop-types';

import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const styles = () => ({
	root: {
		height: 'calc(100% - 50px)',
	},
	content: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		flex: '1 0 100%',
		height: '100%',
		justifyContent: 'center',
	},
	loading: {
		height: 24,
		margin: 'auto 0',
		width: 24,
	},
});

class Loading extends Component {

	renderLoading = (
		<div className={this.props.className}>
			<CircularProgress
				color="primary"
				size={25}
			/>
		</div>
	)

	render() {
		const { classes, className } = this.props;

		return (
			<div className={clsx(classes.root, className)}>
				<div className={classes.content}>
					{this.renderLoading}
				</div>
			</div>
		);
	}
}

Loading.propTypes = {
	classes: PropTypes.object.isRequired,
	className: PropTypes.string,
}

export default withStyles(styles)(Loading);